import { useState } from 'react';

import { APPROVAL_WORKFLOW_TYPES } from '../_constants';
import styles from '../../../ApplicationMaintenance.module.scss';
import WorkFlowSelect from './WorkFlows/WorkFlowSelect';
import MultiLevelApprovals from './WorkFlows/MultiLevelApprovals/MultiLevelApprovals';
import SingleLevelApprovals from './WorkFlows/SingleLevelApprovals';

const ApprovalsUpdate = ({
	appID,
	currentUser,
	app,
	readOnly,
	requirementNumber,
}) => {
	const [approvalFlowType, setApprovalFlowType] = useState(null);

	//render component conditionally based on selected application approval work flow
	const renderWorkFlowComponent = () => {
		switch (approvalFlowType) {
			case APPROVAL_WORKFLOW_TYPES.MultiLevel:
				return (
					<MultiLevelApprovals
						app={app}
						currentUser={currentUser}
						readOnly={readOnly}
						requirementNumber={requirementNumber}
					/>
				);
			case APPROVAL_WORKFLOW_TYPES.SingleLevel:
				return (
					<SingleLevelApprovals
						app={app}
						currentUser={currentUser}
						readOnly={readOnly}
						requirementNumber={requirementNumber}
					/>
				);
			default:
				return (
					<p className={styles.text_center}>
						please select the approval work flow type that you wish
						to modify
					</p>
				);
		}
	};

	return (
		<>
			<WorkFlowSelect
				currentUser={currentUser}
				setApprovalFlowType={setApprovalFlowType}
				app={app}
			/>
			<>{renderWorkFlowComponent()}</>
		</>
	);
};

export default ApprovalsUpdate;
